import values from 'lodash/values';
import find from 'lodash/find';
import get from 'lodash/get';
import isNumber from 'lodash/isNumber';

import { formatMoney } from '../../../shared/format';
import createSort from '../../../shared/table/create-sort.js';

const defaultInitialState = {
	columns: {
		id: {
			index: 'id',
			title: 'Id',
			direction: 'desc'
		},
		cpa: {
			index: 'cpa',
			title: 'CPA'
		},
		nickname: {
			index: 'nickname',
			title: 'Nickname',
			direction: 'desc'
		},
		contacts: {
			index: 'contacts',
			title: 'Contacts'
		},
		description: {
			index: 'description',
			title: 'Comment'
		},
		language: {
			index: 'language',
			title: 'Lang'
		},
		manager: {
			index: 'manager',
			title: 'Manager',
			className: 'modify-border-dashed'
		},
		internal_rank: {
			index: 'internal_rank',
			title: 'Rank',
			direction: 'desc'
		},
		internal_status: {
			index: 'internal_status',
			title: 'Status',
			direction: 'desc',
			className: 'modify-border'
		},
		rank_id: {
			index: 'rank_id',
			title: 'Rank',
			direction: 'desc',
			className: 'modify-border'
		},
		balance_points: {
			index: 'balance_points',
			title: 'Q',
			direction: 'desc',
			className: 'balance'
		},
		balance_rub: {
			index: 'balance_rub',
			title: '₽',
			direction: 'desc',
			className: 'balance'
		},
		balance_usd: {
			index: 'balance_usd',
			title: '$',
			direction: 'desc',
			className: 'balance'
		},
		balance_eur: {
			index: 'balance_eur',
			title: '€',
			direction: 'desc',
			className: 'modify-border balance'
		},
		referer: {
			index: 'referer',
			title: 'Referer',
			direction: 'desc'
		},
		tags: {
			index: 'tags',
			title: 'Tags'
		},
		lead_sources: {
			index: 'lead_sources',
			title: 'Lead sources'
		},
		created_at: {
			index: 'created_at',
			title: 'Signed up',
			direction: 'desc'
		},
		actions: {
			title: 'Actions'
		}
	},
	sortByColumn: {
		index: 'id',
		title: 'Id',
		direction: 'desc'
	}
};

const createTable = ({
	namespace,
	stateNodeName,
	configureSort
}) => {

	const sort = createSort(namespace, stateNodeName, {
		type: configureSort.type,
		resolverSortFn: configureSort.resolverSortFn
	});

	// action types
	const SHOW_MORE_ROWS = `${namespace}/table-show-more-rows`;

	if (process.env.CPA_ENV === 'everad') {
		delete defaultInitialState.columns.rank_id;
		delete defaultInitialState.columns.balance_points;
		delete defaultInitialState.columns.created_at;
	} else {
		delete defaultInitialState.columns.internal_rank;
		delete defaultInitialState.columns.internal_status;
		delete defaultInitialState.columns.referer;
		delete defaultInitialState.columns.balance_rub;
		delete defaultInitialState.columns.tags;
		delete defaultInitialState.columns.balance_eur;
		delete defaultInitialState.columns.lead_sources;
	}

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = Object.assign({
		showMoreRows: () => ({
			type: SHOW_MORE_ROWS
		})
	}, sort.actions);

	// reducers
	const reducers = Object.assign({}, sort.reducers);

	// selectors
	const selectors = {
		getTable: state => {
			const { table, data } = state[namespace];
			const rows = data ? sort.order(data, table.sortByColumn) : [];
			const lists = state.root.lists;
			const availableCurrencies = selectors.getAvailableCurrencies(state);
			const mappedRows = rows.map(row => ({
				...row,
				internal_rank: getTextFromList(lists['affiliate-internal-ranks'], row['internal_rank']),
				internal_status: getTextFromList(lists['affiliate-internal-statuses'], row['internal_status']),
				balance_points: isNumber(+row.balance_points) ? formatMoney(row.balance_points, true) : '-',
				...availableCurrencies.reduce(
					(acc, value) => {
						acc[`balance_${value}`] = isNumber(get(row, `balances.${value}`))
							? formatMoney(row.balances[value], true)
							: '-';
						return acc;
					}, {}
				)
			}));

			return {
				headers: values(table.columns),
				rows: mappedRows,
				sortedColumn: table.sortByColumn,
				rowsNumber: table.rowsNumber,
				totalRows: rows.length
			};
		},
		getAvailableCurrencies: state => state.root.lists['available-currencies'].map(currency => currency.id)
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

const getTextFromList = (lists, id) => get(find(lists, { id }), 'text');

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/table/index.js